import { Button, Input, Select, Table } from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import AxiosInstance from "../../../../AxiosInstance";
import { useNavigate } from "react-router-dom";
import { amountFormat, obj2url } from "../../../../utils";
import styles from "../partnerDashboard.module.css";

export default function TrackAssignmentInvView() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [summaryData, setSummaryData] = useState({});

  const [filters, setFilters] = useState({
    status: "",
    policyNumber: "",
  });
  const navigate = useNavigate();
  var [dataSource, setDataSource] = useState([]);

  const getSummaryData = useCallback(async () => {
    const url = `/partner/referral/INVESTOR/summary?status=${filters.status}`;
    try {
      const resp = await AxiosInstance().get(url);
      let { data } = resp;
      setSummaryData(data); // Set the summary data in state
    } catch (error) {
      console.error("Error fetching summary data:", error);
    }
  }, [filters.status]);

  useEffect(() => {
    getTableData(0, filters);
    getSummaryData();
  }, [filters, getSummaryData]);

  const getTableData = async (skip, filters) => {
    const url =
      `partner/referral/investments?take=10&skip=${skip}` + obj2url(filters);
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const columns = [
    {
      title: "Refer Date",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Policy Number",
      dataIndex: "policy.policyNumber",
      align: "center",
      key: "policy.policyNumber",
      render: (text, policy) => <>{policy.policy.policyNumber}</>,
    },
    {
      title: "Name of Investor",
      dataIndex: "name",
      key: "name",
      render: (text, policy) =>
        policy.investor["firstName"] + " " + policy.investor["lastName"],
    },
    {
      title: "Insurer",
      dataIndex: "insurer",
      key: "insurer",
      align: "center",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy.policy?.insurer?.logo}
          />
        </>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
    },
  ];

  const handleFilterChange = (value, type) => {
    setFilters((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const change = (data) => {
    getTableData((data - 1) * 10, filters);
  };

  return (
    <div>
      <div className="d-flex justify-content-center my-4">
        {" "}
        <div
          className={`ph-summary p-4 shadow ${styles["partner-summary-card"]}`}
        >
          {" "}
          {/* <div className="row">
            {" "}
            <div className="col">
              Total Incentive: {amountFormat(summaryData?.amount)}
            </div>
            <div className="col">
              Investment Amount: {amountFormat(summaryData?.investmentAmount)}
            </div>
          </div> */}
          <div className="row mt-2">
            {" "}
            <div className="col">
              No. of Policies: {amountFormat(summaryData?.totalPolicyCount)}
            </div>
            <div className="col">
              Investment Amount:{" "}
              {amountFormat(summaryData?.totalInvestmentAmount)}
            </div>
            {/* <div className="col">
                Total Fund Value:{" "}
                {amountFormat(summaryData?.totalCurrentSurrenderValue)}
              </div> */}
          </div>
          {/* <div className="d-flex justify-content-center mt-2">
              Total Investments:{" "}
              {amountFormat(summaryData?.totalInvestmentAmount)}
            </div> */}
        </div>
      </div>
      <div className="d-flex gap-2 mb-3">
        <Select
          style={{ width: 200 }}
          placeholder="Select Status"
          value={filters.status}
          onChange={(value) => handleFilterChange(value, "status")}
        >
          <Select.Option value="">All</Select.Option>
          <Select.Option value="DONE">Active</Select.Option>
          <Select.Option value="PENDING,SENT,PAYMENT_PENDING,PAYMENT_DONE">
            InProgress
          </Select.Option>
          <Select.Option value="REJECTED">Rejected</Select.Option>
          {/* <Select.Option value="DONE">Matured</Select.Option> */}
        </Select>

        <Input
          style={{ width: 200 }}
          name="policyNumber"
          placeholder="Search Policy Number"
          value={filters.policyNumber}
          onChange={(e) => handleFilterChange(e.target.value, "policyNumber")}
        />
      </div>

      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />
    </div>
  );
}
